/* defines which type of roller is used for a case */
export enum ROLLER_TYPE {
  NONE = 0,
  CORNER_INBOARD = 1,
  CORNER_OUTBOARD = 2,
  EDGE = 3,
  CREEPER = 4,
}

/** German labels for Rollentyp (e.g. Optionsbibliothek editor). */
export const ROLLER_TYPE_LABEL_DE: Record<ROLLER_TYPE, string> = {
  [ROLLER_TYPE.NONE]: "Keine",
  [ROLLER_TYPE.CORNER_INBOARD]: "Einbau-Eckrolle",
  [ROLLER_TYPE.CORNER_OUTBOARD]: "Aufbau-Eckrolle",
  [ROLLER_TYPE.EDGE]: "Kantenrolle",
  [ROLLER_TYPE.CREEPER]: "Bodenrolle",
};
